import platformConfigtSaga from './saga';

export default platformConfigtSaga;
